module.exports = __webpack_public_path__ + "media/audio78.16e3186e.mp3";